// ======================================================================
// FILE: src/modules/wms/team/pages/TeamMembersPage.jsx
// MODULE: Work Management System (WMS)
// FEATURE: Team Management
// PURPOSE:
//   Manage Team Members
// ======================================================================

import React, {
  useEffect,
  useState,
} from "react";

import {
  useParams,
  useNavigate,
} from "react-router-dom";

import wmsTeamService
from "../../services/wmsTeamService";

export default function TeamMembersPage() {

  const { id } = useParams();

  const navigate = useNavigate();

  const [team, setTeam] =
    useState(null);

  const [members, setMembers] =
    useState([]);
  const [users, setUsers] =
  useState([]);


  const [loading, setLoading] =
    useState(false);

  const [saving, setSaving] =
    useState(false);
    const [editingMemberId, setEditingMemberId] =
  useState(null);


  const [form, setForm] =
    useState({

       user_id: "",

        member_code: "",

        member_name: "",

        email: "",

        mobile: "",

        designation: "",

        is_team_lead: false,

        joined_date: "",

        remarks: "",
    });

  // ==========================================================
  // LOAD
  // ==========================================================

  useEffect(() => {

    loadData();

  }, [id]);

  async function loadData() {

    try {

      setLoading(true);

      const [
        teamData,
        memberData,
        userData
      ] = await Promise.all([
        wmsTeamService.getTeam(id),
        wmsTeamService.getMembers(id),
        wmsTeamService.getAvailableUsers(),
      ]);

      setTeam(teamData);

      setMembers(memberData || []);

      setUsers(userData || []);

    } catch (err) {

      alert(
        err?.response?.data?.message
        || "Failed to load data"
      );

    } finally {

      setLoading(false);
    }
  }

  
  // ==========================================================
  // EDIT MEMBER
  // ==========================================================
  function handleEditMember(member) {

  setEditingMemberId(member.id);

  setForm({

    user_id: member.user_id,

    member_code: member.member_code || "",

    member_name: member.member_name || "",

    email: member.email || "",

    mobile: member.mobile || "",

    designation: member.designation || "",

    is_team_lead: member.is_team_lead,

    joined_date: member.joined_date || "",

    remarks: member.remarks || "",
  });
}

function resetForm() {

  setEditingMemberId(null);

  setForm({

    user_id: "",

    member_code: "",

    member_name: "",

    email: "",

    mobile: "",

    designation: "",

    is_team_lead: false,

    joined_date: "",

    remarks: "",
  });
}
  
  // ==========================================================
  // ADD MEMBER
  // ==========================================================

  async function handleAddMember() {


if (!form.member_name) {

  alert(
    "Member Name is required"
  );

  return;
}

    try {

      setSaving(true);

      if (editingMemberId) {

  await wmsTeamService.updateMember(
    id,
    editingMemberId,
    {
      user_id: Number(form.user_id),

      member_code: form.member_code,

      member_name: form.member_name,

      email: form.email,

      mobile: form.mobile,

      designation: form.designation,

      is_team_lead: form.is_team_lead,

      joined_date: form.joined_date || null,

      remarks: form.remarks,
    }
  );

} else {

  await wmsTeamService.addMember(
    id,
    {
      user_id: Number(form.user_id),

      member_code: form.member_code,

      member_name: form.member_name,

      email: form.email,

      mobile: form.mobile,

      designation: form.designation,

      is_team_lead: form.is_team_lead,

      joined_date: form.joined_date || null,

      remarks: form.remarks,
    }
  );
}

 resetForm();

      await loadData();

    } catch (err) {

      alert(
        err?.response?.data?.message
        || "Failed to add member"
      );

    } finally {

      setSaving(false);
    }
  }

  // ==========================================================
  // REMOVE MEMBER
  // ==========================================================

  async function handleRemoveMember(
    member
  ) {

    const ok = window.confirm(
      "Remove member from team?"
    );

    if (!ok) return;

    try {

      await wmsTeamService.removeMember(
        id,
        member.id
      );

      await loadData();

    } catch (err) {

      alert(
        err?.response?.data?.message
        || "Failed to remove member"
      );
    }
  }

  // ==========================================================
  // UI
  // ==========================================================

  return (

    <div className="container-fluid">

      {/* HEADER */}

      <div
        className="d-flex justify-content-between align-items-center mb-3"
      >

        <div>

          <h3>
            Team Members
          </h3>

          <div>

            Team:

            {" "}

            <strong>
              {team?.team_name}
            </strong>

          </div>

        </div>

        <button
          className="btn btn-secondary"
          onClick={() =>
            navigate("/wms/teams")
          }
        >
          Back
        </button>

      </div>

      {/* ADD MEMBER */}

      <div className="card mb-3">

        <div className="card-header">

          <strong>
            Add Member
          </strong>

        </div>

        <div className="card-body">

          <div className="row">

            <div className="col-md-3">

              <label>
  Select User *
</label>

<select
  className="form-select"
  value={form.user_id}
  onChange={(e) =>
    setForm({
      ...form,
      user_id: e.target.value,
    })
  }
>
  <option value="">
    Select User
  </option>

  {users.map((user) => (
    <option
      key={user.id}
      value={user.id}
    >
      {user.id} - {user.username}
    </option>
  ))}
</select>

            </div>
            <div className="col-md-3">

  <label>
    Member Code
  </label>

  <input
    className="form-control"
    value={form.member_code}
    onChange={(e) =>
      setForm({
        ...form,
        member_code:
          e.target.value,
      })
    }
  />

</div>

<div className="col-md-3">

  <label>
    Member Name *
  </label>

  <input
    className="form-control"
    value={form.member_name}
    onChange={(e) =>
      setForm({
        ...form,
        member_name:
          e.target.value,
      })
    }
  />

</div>

<div className="col-md-3">

  <label>
    Email
  </label>

  <input
    type="email"
    className="form-control"
    value={form.email}
    onChange={(e) =>
      setForm({
        ...form,
        email:
          e.target.value,
      })
    }
  />

</div>

            
            <div className="col-md-3">

  <label>
    Mobile
  </label>

  <input
    className="form-control"
    value={form.mobile}
    onChange={(e) =>
      setForm({
        ...form,
        mobile:
          e.target.value,
      })
    }
  />

</div>

<div className="col-md-3">

  <label>
    Designation
  </label>

  <input
    className="form-control"
    value={form.designation}
    onChange={(e) =>
      setForm({
        ...form,
        designation:
          e.target.value,
      })
    }
  />

</div>
            <div className="col-md-3">

              <label>
                Joined Date
              </label>

              <input
                type="date"
                className="form-control"
                value={form.joined_date}
                onChange={(e) =>
                  setForm({
                    ...form,
                    joined_date:
                      e.target.value,
                  })
                }
              />

            </div>

            <div
              className="col-md-3 d-flex align-items-end"
            >

              <div
                className="form-check"
              >

                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={
                    form.is_team_lead
                  }
                  onChange={(e) =>
                    setForm({
                      ...form,
                      is_team_lead:
                        e.target.checked,
                    })
                  }
                />

                <label
                  className="form-check-label"
                >
                  Team Lead
                </label>

              </div>

            </div>

            <div className="col-md-12 mt-3">

              <label>
                Remarks
              </label>

              <textarea
                rows="2"
                className="form-control"
                value={form.remarks}
                onChange={(e) =>
                  setForm({
                    ...form,
                    remarks:
                      e.target.value,
                  })
                }
              />

            </div>

          </div>

        </div>

        <div className="card-footer">

          <button
  className="btn btn-primary me-2"
  onClick={handleAddMember}
  disabled={saving}
>
  {saving
    ? "Saving..."
    : editingMemberId
      ? "Update Member"
      : "Add Member"}
</button>

{editingMemberId && (

  <button
    className="btn btn-secondary"
    onClick={resetForm}
  >
    Cancel
  </button>

)}

        </div>

      </div>

      {/* MEMBERS GRID */}

      <div className="card">

        <div className="card-header">

          <strong>
            Members
          </strong>

        </div>

        <div className="card-body p-0">

          <table
            className="table table-bordered table-hover mb-0"
          >

            <thead>

              <tr>

                <th>
  Member Code
</th>

<th>
  Member Name
</th>

<th>
  Email
</th>

<th>
  Mobile
</th>

<th>
  Team Lead
</th>

<th>
  Joined Date
</th>

<th>
  Remarks
</th>

                <th width="120">
                  Actions
                </th>

              </tr>

            </thead>

            <tbody>

              {loading && (

                <tr>

                  <td
                    colSpan="8"
                    className="text-center"
                  >
                    Loading...
                  </td>

                </tr>
              )}

              {!loading &&
                members.length === 0 && (

                <tr>

                  <td
                    colSpan="5"
                    className="text-center"
                  >
                    No Members Found
                  </td>

                </tr>
              )}

              {!loading &&
                members.map(
                  (member) => (

                  <tr
                    key={member.id}
                  >

                    <td>
  {member.member_code}
</td>

<td>
  {member.member_name}
</td>

<td>
  {member.email}
</td>

<td>
  {member.mobile}
</td>

<td>

  {member.is_team_lead
    ? "Yes"
    : "No"}

</td>

<td>
  {member.joined_date}
</td>

<td>
  {member.remarks}
</td>

                    <td>

  <button
    className="btn btn-sm btn-primary me-2"
    onClick={() =>
      handleEditMember(member)
    }
  >
    Edit
  </button>

  <button
    className="btn btn-sm btn-danger"
    onClick={() =>
      handleRemoveMember(member)
    }
  >
    Remove
  </button>

</td>

                  </tr>
                ))}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
}